import React from 'react';

/**
 * Renders the full cumulative listing timeline for the "Completed Time" column
 * used across CX, CX Leader, Executive and Admin task views.
 *
 * Expects the backend `completed_time` object:
 *   { start_time, review_time, reject_time, completion_time,
 *     review_duration, total_effective_time, segments: [{label, duration}] }
 */
const SEG_CLS = {
  'Working': 'bg-blue-50 text-blue-700',
  'Under Review': 'bg-amber-50 text-amber-700',
  'Reject': 'bg-rose-50 text-rose-700',
  'Completed': 'bg-emerald-50 text-emerald-700',
};

const fmtTs = (iso) => (iso ? new Date(iso).toLocaleString() : null);

const CompletedTimeCell = ({ ct }) => {
  const hasData = ct && (ct.start_time || (Array.isArray(ct.segments) && ct.segments.length > 0));
  if (!hasData) return <span className="text-gray-300 text-xs" data-testid="completed-time-empty">—</span>;

  return (
    <div className="flex flex-col gap-1 min-w-[170px]" data-testid="completed-time-cell">
      {ct.total_elapsed_time && (
        <span className="text-xs font-semibold text-gray-800" data-testid="completed-time-total">
          Total: {ct.total_elapsed_time}
        </span>
      )}
      {ct.total_effective_time && (
        <span className="text-[10px] text-gray-500" data-testid="completed-time-effective">
          Effective: {ct.total_effective_time}
        </span>
      )}
      {Array.isArray(ct.segments) && ct.segments.length > 0 && (
        <div className="flex flex-wrap gap-1" data-testid="completed-time-segments">
          {ct.segments.map((s, i) => (
            <span key={i} className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${SEG_CLS[s.label] || 'bg-gray-100 text-gray-600'}`}>
              {s.label} · {s.duration}
            </span>
          ))}
        </div>
      )}
      <div className="text-[10px] text-gray-400 leading-tight space-y-0.5">
        {ct.start_time && <div>Start: {fmtTs(ct.start_time)}</div>}
        {ct.review_time && <div>Review: {fmtTs(ct.review_time)}{ct.review_duration ? ` (${ct.review_duration})` : ''}</div>}
        {ct.reject_time && <div>Reject: {fmtTs(ct.reject_time)}</div>}
        {ct.completion_time && <div>Complete: {fmtTs(ct.completion_time)}</div>}
      </div>
    </div>
  );
};

export default CompletedTimeCell;
